import { createFileRoute } from '@tanstack/react-router';
import { EditProfilePage } from '../components/community/EditProfilePage';

export const Route = createFileRoute('/community/profile/edit')({
  component: EditProfilePage,
});
